/**
 * Blurs element after click to prevent visual focus effect after clicking
 */
export function blurElementAfterClick(target: HTMLElement): void {
    target.blur();
    setTimeout(() => target.blur());
}
